import { useQuery } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import type { AdminUserListParams } from '../types/admin-user.types';
import { adminUserKeys } from './queryKeys';

export const useAdminUsers = (params: AdminUserListParams = {}) => {
  return useQuery({
    queryKey: adminUserKeys.list(params),
    queryFn: async () => {
      const response = await adminUsersApi.listUsers(params);
      return response.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};
